export const projectSystemInfoSlotList=[
    'projectSystemInfos_analyzeRequirements',
    'projectSystemInfos_sampleNum',
    'projectSystemInfos_contractStatus',
    'projectSystemInfos_contractType',
    'projectSystemInfos_sequencingPlatform',
    'projectSystemInfos_planAmountSet',
    'projectSystemInfos_planAmountSet1',
    'projectSystemInfos_contractSampleNum',
    'projectSystemInfos_dataEnoughStatus'
]
